import React, {useState, useReducer} from 'react';
import Main from "../../modules/main/main";
import {apiReports} from "../../services/api/reports";
import './reports.scss';

function Reports(props) {
    let breadcrumbs = [
        {"name": "Reports", "active": true},
    ];

    const [showDownload, setShowDownload] = useState(false);
    const [downloadLabel, setDownloadLabel] = useState(false);
    const [selectedApplication, setSelectedApplication] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('approved'); // Default to 'approved'
    const [, forceUpdate] = useReducer(x => x + 1, 0);

    const saveFile = async (blob, type) => {
        const fileurl = window.URL.createObjectURL(new Blob([blob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));

        const link = document.createElement('a');
        link.href = fileurl;

        link.setAttribute('download', `${type}-report.xlsx`);
        document.body.appendChild(link);

        link.click();
        
        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileurl);
    };

    // Generate year options (current year and past 10 years)
    const getYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = 0; i <= 10; i++) {
            years.push(currentYear - i);
        }
        return years;
    };

    const handleApplicationChange = (e) => {
        const appType = e.target.value;
        setSelectedApplication(appType);
        setSelectedYear(''); // Reset year when application changes
        setSelectedStatus('approved'); // Reset status to default when application changes
        setShowDownload(false);
        setDownloadLabel('');
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
    };

    const load_filters = () => {
        if (!selectedApplication) {
            return;
        }

        // For Empower, require year selection
        if (selectedApplication === 'empower' && !selectedYear) {
            alert('Please select a year for Empower reports');
            return;
        }

        setDownloadLabel(`Download ${selectedApplication.toUpperCase()}${selectedYear ? ` ${selectedYear}` : ''}${selectedStatus ? ` - ${selectedStatus.replace('_', ' ').toUpperCase()}` : ''}`);
        setShowDownload(true);
        
        let queryParams = `type=${selectedApplication}`;
        if (selectedApplication === 'empower' && selectedYear) {
            queryParams += `&year=${selectedYear}`;
        }
        if (selectedApplication === 'empower' && selectedStatus) {
            queryParams += `&status=${selectedStatus}`;
        }
        
        apiReports.getAll(queryParams).then((data) => {
            console.log(data);
            saveFile(data, selectedApplication);
        }).catch((error) => {
            console.error('Error downloading report:', error);
            alert('Error downloading report. Please try again.');
        });
        forceUpdate();
    };


    return (
        <Main title="Reports" breadcrumbs={breadcrumbs}>
            <div className="card card-primary reports-page">
                <div className="card-header">
                    <h3 className="card-title">Generate Report</h3>
                </div>
                <div className="card-body">
                    <form className="form-horizontal">
                        <div className="form-group row">
                            <label htmlFor="applicationSelect" className="col-sm-2 col-form-label">Select Application</label>
                            <div className="col-sm-4">
                                <select 
                                    id="applicationSelect"
                                    name="application" 
                                    className="form-control" 
                                    onChange={handleApplicationChange} 
                                    value={selectedApplication}
                                >
                                    <option value="">Select an Application</option>
                                    <option key="empower" value="empower">EMPOWER</option>
                                </select>
                            </div>
                        </div>

                        {selectedApplication === 'empower' && (
                            <>
                                <div className="form-group row">
                                    <label htmlFor="yearSelect" className="col-sm-2 col-form-label">Select Year</label>
                                    <div className="col-sm-4">
                                        <select 
                                            id="yearSelect"
                                            name="year" 
                                            className="form-control" 
                                            onChange={handleYearChange}
                                            value={selectedYear}
                                        >
                                            <option value="">Select a Year</option>
                                            {getYearOptions().map(year => (
                                                <option key={year} value={year}>{year}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label htmlFor="statusSelect" className="col-sm-2 col-form-label">Select Status</label>
                                    <div className="col-sm-4">
                                        <select 
                                            id="statusSelect"
                                            name="status" 
                                            className="form-control" 
                                            onChange={handleStatusChange}
                                            value={selectedStatus}
                                        >
                                            <option value="approved">Approved</option>
                                            <option value="need_more_info">Need More Info</option>
                                            <option value="rejected">Rejected</option>
                                            <option value="pending_review">Pending Review</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="form-group row">
                            <div className="col-sm-2"></div>
                            <div className="col-sm-10">
                                {selectedApplication && (
                                    selectedApplication === 'empower' && selectedYear ? (
                                        <button 
                                            type="button"
                                            className="btn btn-primary" 
                                            onClick={load_filters}
                                        >
                                            <i className="fas fa-download mr-2"></i>
                                            {showDownload ? downloadLabel : `Download ${selectedApplication.toUpperCase()}${selectedYear ? ` ${selectedYear}` : ''}${selectedStatus ? ` - ${selectedStatus.replaceAll('_', ' ').toUpperCase()}` : ''}`}
                                        </button>
                                    ) : (
                                        selectedApplication === 'empower' && !selectedYear && (
                                            <div className="alert alert-info">
                                                <i className="fas fa-info-circle mr-2"></i>
                                                Please select a year to generate the Empower report.
                                            </div>
                                        )
                                    )
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Main>
    );
}

export default Reports;